import { Injectable } from '@angular/core';
import { AccountInfo } from '@azure/msal-browser';
import { CurrentUserLoad } from '../store/actions';
import { MsalService } from '@azure/msal-angular';
import { Store } from '@ngrx/store';
import { UserAvatarService } from '../services/user-avatar.service';

@Injectable({ providedIn: 'root' })
export class UserFacade {
  private initPromise: Promise<void> | null = null;
  private redirectInFlight = false;

  constructor(
    private readonly authService: MsalService,
    private store: Store,
    private readonly userAvatar: UserAvatarService,
  ) {}

  public async init() {
    if (this.initPromise) {
      return this.initPromise;
    }

    this.initPromise = this.initializeUserContext().finally(() => {
      this.initPromise = null;
    });

    return this.initPromise;
  }

  private async initializeUserContext(): Promise<void> {
    await this.authService.instance.handleRedirectPromise();

    const accounts = this.authService.instance.getAllAccounts();
    this.ensureActiveAccount(accounts);

    if (!this.authService.instance.getActiveAccount()) {
      if (!this.redirectInFlight) {
        this.redirectInFlight = true;
        await this.authService.instance.loginRedirect();
      }
      return;
    }

    this.redirectInFlight = false;
    this.store.dispatch(new CurrentUserLoad());
    this.userAvatar.loadAvatar();
  }

  private ensureActiveAccount(accounts: AccountInfo[]): void {
    if (!this.authService.instance.getActiveAccount() && accounts.length > 0) {
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }
}
